import InstrumentIcon from "../../../instrument-icon";
import moment from "moment";
import Big from "big.js";
import {useSelector} from "react-redux";
import {Tooltip} from "react-tooltip";
import {useTranslation} from "react-i18next";
import SvgIcon from "../../../svg-icon";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {Link} from "react-router-dom";
import stringHelper from "../../../../helpers/string-helper";


const GeneralStatsItemRoller = props => {
    const {t, i18n} = useTranslation()
    const currentLanguage = i18n.language; // Get the current language
    const {stat, handleUserDetail} = props
    const {
        selectedFiat,
        fiatRates
    } = useSelector(state => state.authenticationReducer)
    const {symbols} = useSelector(state => state.globalReducer)


    return (
        <tr key={stat?.id}>
            <td>
                <div className="xtable__text__80 cursor-pointer gap-1 align-items-center d-flex">
                    <LazyLoadImage
                        effect="blur"
                        threshold="100"
                        className="row-game-img"
                        placeholderSrc={stat?.game?.game_website?.image}
                        src={stat?.game?.game_website?.image} alt=""/>
                    <Link
                        to={stringHelper.getLocalizedPath(currentLanguage, `/casino/games/${stat?.game?.slug}`)}
                    >{stat?.game?.name}</Link>
                </div>
            </td>
            <td>
                <div
                    onClick={e => handleUserDetail(stat)}
                    className="xtable__text cursor-pointer">
                    {stat?.customer?.is_public ? stat?.customer?.username :

                        <span className="d-flex align-items-center justify-content-center gap-1">
                        <SvgIcon id={'hidden'}/>
                            {t('general.hidden')}
                    </span>
                    }
                </div>
            </td>
            <td className="text-right">
                <div className="xtable__coin gap-1 text-secondary">
                    <span>{symbols[selectedFiat]}</span>

                    <Tooltip className="tooltip-me" anchorSelect={`#bet-amount-${stat.id}`}>
                        <span className="xtable__coin gap-1">
                            {Big(stat?.amount || 0)
                                .toFixed(['TRY', 'USD', 'USDT'].includes(stat.wallet_currency) ? 2 : 5)
                            }
                            <InstrumentIcon code={stat?.currency}/>
                        </span>
                    </Tooltip>


                    <span className="xtable__coin text-secondary" id={`bet-amount-${stat.id}`}>
                        {
                            selectedFiat ? Big(stat?.amount || 0).div(fiatRates[stat.currency] || 1)
                                    .toFixed(['TRY', 'USD', 'USDT'].includes(stat.currency) ? 2 : 5)
                                :
                                Big(stat?.amount || 0)
                                    .toFixed(['TRY', 'USD', 'USDT'].includes(stat.currency) ? 2 : 5)
                        }
                        </span>


                    <InstrumentIcon code={stat?.currency}/>


                </div>
            </td>
            <td className="text-right">
                <div className="xtable__text">
                    x{parseFloat(stat?.multiplier || 0) >= 0 ? Big(stat?.multiplier || 0).toFixed(2) : Big(0).toFixed(2)}
                </div>
            </td>
            <td>
                <div
                    className={`xtable__coin ${stat?.multiplier >= 1 ? 'xtable__coin--green' : 'text-secondary'} gap-1`}>

                    <span>{symbols[selectedFiat]}</span>

                    <Tooltip className="tooltip-me" anchorSelect={`#win-amount-${stat.id}`}>
                        <span className="xtable__coin gap-1">
                            {
                                Big(stat?.income || 0).minus(parseFloat(stat?.multiplier) === 1 ? 0 : (stat?.amount || 0))
                                    .toFixed(['TRY', 'USD', 'USDT'].includes(stat.wallet_currency) ? 2 : 5)
                            }
                            <InstrumentIcon code={stat?.wallet_currency}/>
                        </span>
                    </Tooltip>

                    <span id={`win-amount-${stat.id}`}>
                    {
                        selectedFiat ?
                            Big(stat?.income || 0).minus(parseFloat(stat?.multiplier) === 1 ? 0 : (stat?.amount || 0))
                                .div(fiatRates[stat.wallet_currency] || 1)
                                .toFixed(8)
                            : Big(stat?.income || 0).minus(parseFloat(stat?.multiplier) === 1 ? 0 : (stat?.amount || 0)).toFixed(['TRY', 'USD', 'USDT'].includes(stat.wallet_currency) ? 2 : 5)

                    }
                    </span>

                    <InstrumentIcon code={stat?.currency}/>
                </div>
            </td>
        </tr>

    )

}

export default GeneralStatsItemRoller
